//components/mobile
import React, { useState } from "react";
import { BottomNavigation, BottomNavigationAction, Paper } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom"; // Import useNavigate
import OrderIcon from "@mui/icons-material/Assignment";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import UsersIcon from "@mui/icons-material/Person";
import BlockIcon from "@mui/icons-material/Block";
import UpdateIcon from "@mui/icons-material/Update";
import { useAtom } from "jotai";
import {
    openAvailabilityDialogAtom,
    openUserDialogAtom,
    userModalTabValue
} from "../../atoms/usersTable";
import { openBlockedTimeDialogAtom } from "../../atoms/blockedTime";
import { openManageBookingDialogAtom } from "../../atoms/bookingsTable";

const MobileNavBar = () => {
    const [, setOpenUserDialog] = useAtom(openUserDialogAtom);
    const [, setTabValue] = useAtom(userModalTabValue);
    const [, setOpenAvailabilityDialog] = useAtom(openAvailabilityDialogAtom);
    const [, setOpenBlockedTimeDialog] = useAtom(openBlockedTimeDialogAtom);
    const [, setOpenManageBookingDialog] = useAtom(openManageBookingDialogAtom);
    const location = useLocation();
    const navigate = useNavigate();
    const [activeNavItem, setActiveNavValue] = useState(
        location.pathname.includes("bookings")
            ? "bookings"
            : location.pathname.includes("calendar")
              ? "calendar"
              : ""
    );

    return (
        <Paper
            sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}
            elevation={3}
        >
            <BottomNavigation
                showLabels
                value={activeNavItem}
                onChange={(event, newValue) => {
                    setActiveNavValue(newValue);
                    setOpenAvailabilityDialog(false);
                    setOpenBlockedTimeDialog(false);
                    setOpenManageBookingDialog(false);

                    switch (newValue) {
                        case "bookings":
                            navigate("/bookings");
                            setOpenUserDialog(false);
                            break;
                        case "calendar":
                            navigate("/calendar");
                            setOpenUserDialog(false);
                            break;
                        case "profile":
                            setTabValue(0);
                            setOpenUserDialog(true);
                            break;
                        case "availability":
                            setTabValue(1);
                            setOpenUserDialog(true);
                            break;
                        case "block-time":
                            setTabValue(2);
                            setOpenUserDialog(true);
                            break;
                        default:
                            break;
                    }
                }}
            >
                <BottomNavigationAction
                    label="Bookings"
                    value="bookings"
                    icon={<OrderIcon />}
                />
                <BottomNavigationAction
                    label="Calendar"
                    value="calendar"
                    icon={<InsertInvitationIcon />}
                />
                <BottomNavigationAction
                    label="Profile"
                    value="profile"
                    icon={<UsersIcon />}
                />
                <BottomNavigationAction
                    label="Availability"
                    value="availability"
                    icon={<UpdateIcon />}
                />
                <BottomNavigationAction
                    label="Block time"
                    value="block-time"
                    icon={<BlockIcon />}
                />
            </BottomNavigation>
        </Paper>
    );
};

export default MobileNavBar;
